<template>
  <div class="contenter buyerfinder-contenter" id="top">
    <div class="header" v-if="!exhibition">
      <div class="logocontain">
        <span class="logo" />
      </div>
      <div class="search">
        <a-select size="large" v-model="searchType" @change="handleTypeChange">
          <a-select-option :value="0">国外采购商</a-select-option>
          <a-select-option :value="1">采购产品名称</a-select-option>
          <a-select-option :value="2">国外展会名录</a-select-option>
          <a-select-option :value="3">国际展会</a-select-option>
        </a-select>
        <a-input
          @pressEnter="search"
          size="large"
          placeholder="请输入相关检索词..."
          v-model="searchCondition"
          style="flex:1;"
        />

        <div class="selected">
          <span v-if="!!selecter.industryName">
            行业:
            <a>{{selecter.industryName}}</a>
            <a-icon
              type="close-circle"
              @click="()=>{selecter.industry='0';selecter.industryName='';selecter.industryCode='0'/*this.loadIndustryList();*/}"
            />
          </span>
          <span v-if="!!selecter.countryName">
            国家:
            <a>{{selecter.countryName}}</a>
            <a-icon
              type="close-circle"
              @click="()=>{selecter.country='0';selecter.countryName='';}"
            />
          </span>
          <span v-if="!!selecter.sourceName">
            来源:
            <a>{{selecter.sourceName}}</a>
            <a-icon
              type="close-circle"
              @click="()=>{selecter.sourceId='0';selecter.sourceName='';}"
            />
          </span>
          <a
            v-if="!!selecter.countryName||!!selecter.industryName||!!selecter.sourceName"
            @click="()=>{selecter.country='0';selecter.countryName='';selecter.industry='0';selecter.industryName='';selecter.industryCode='0';selecter.sourceId='0',selecter.sourceName=''}"
          >清空全部</a>
        </div>

        <a-button
          type="primary"
          style="width:120px;"
          @click="pageNo=1;search()"
          v-show="!advanced"
        >搜索</a-button>
        <a-button
          type="primary"
          style="width:120px;"
          class="advanced"
          :class="{active:advanced}"
          @click="advanced=!advanced"
        >
          高级搜索
          <a-icon
            :type="`double-${advanced&&'left'||'right'}`"
            style="transform: rotate(90deg) scale(0.7);"
          />
        </a-button>
      </div>
      <div class="advanced-search" v-show="advanced">
        <div class="industry" v-if="true">
          <div>
            <p>按行业:</p>
          </div>
          <div>
            <div style="display:flex;flex-flow:row;">
              <ul :class="[toggle=='industry'?'':'collapse']" style="flex:1;">
                <li v-for="(v,i) in industryList" :key="i">
                  <a-tag
                    :color="selecter.industry==v.id&&'#008cd6'||''"
                    @click="selectIndustry(v)"
                  >{{v.name}}</a-tag>
                </li>
              </ul>
              <div>
                <a-input
                  size="small"
                  style="width: 120px;margin-right:5px"
                  v-model="selecter.industrySearch"
                >
                  <a-icon type="search" slot="prefix" />
                </a-input>
                <a-button class="btn-small-search" size="small">搜索</a-button>
              </div>
            </div>
          </div>
          <div>
            <a @click="toggle=toggle!='industry'&&'industry'||''">
              {{toggle=='industry'&&'收起'||'展开' }}
              <a-icon type="down" />
            </a>
          </div>
        </div>
        <div class="country">
          <div>
            <p>按国家或地区:</p>
          </div>
          <div>
            <div style="display:flex;flex-flow:row;margin-bottom: -16px;">
              <ul class="countrylist" style="flex:1;">
                <li
                  v-for="i in ['全部','A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']"
                  :key="i"
                >
                  <a-tag
                    :style="selecter.alphabet==i&&{}||{color: '#008cd6;'}"
                    :color="selecter.alphabet==i&&'#008cd6'||''"
                    @click="()=>{selecter.alphabet=i;selecter.alphabetSearch='';}"
                  >{{i}}</a-tag>
                </li>
              </ul>
              <div>
                <a-input
                  size="small"
                  style="width: 120px;margin-right:5px;"
                  v-model="selecter.alphabetSearch"
                >
                  <a-icon type="search" slot="prefix" />
                </a-input>
                <a-button class="btn-small-search" size="small" @click="searchAlphabet">搜索</a-button>
              </div>
            </div>
            <ul :class="[toggle=='country'?'':'collapse']">
              <li v-for="v in countryList" :key="v.id">
                <a-tag
                  :color="selecter.country==v.id&&'#008cd6'||''"
                  @click="()=>{selecter.country=v.id;selecter.countryName=v.cnname;}"
                >{{v.cnname}}</a-tag>
              </li>
            </ul>
          </div>
          <div>
            <a @click="toggle=toggle!='country'&&'country'||''">
              {{toggle=='country'&&'收起'||'展开' }}
              <a-icon type="down" />
            </a>
          </div>
        </div>
        <div class="source" v-if="searchType=='0'||searchType=='1'">
          <div>
            <p>按来源:</p>
          </div>
          <div>
            <div style="display:flex;flex-flow:row;">
              <ul :class="[toggle=='source'?'':'collapse']" style="flex:1;">
                <li v-for="(v,i) in base.sourceList" :key="i">
                  <a-tag
                    :color="selecter.sourceId==v.id&&'#008cd6'||''"
                    @click="()=>{selecter.sourceId=v.id;selecter.sourceName=v.name;}"
                  >{{v.name}}</a-tag>
                </li>
              </ul>
            </div>
          </div>
          <div>
            <a @click="toggle=toggle!='source'&&'source'||''">
              {{toggle=='source'&&'收起'||'展开' }}
              <a-icon type="down" />
            </a>
          </div>
        </div>
        <div>
          <a-button type="primary" @click="pageNo=1;search()">搜索</a-button>
          <a-button @click="advanced=false">取消</a-button>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="datalist" v-if="!initial">
        <div class="tip" v-if="accountInfo&&accountInfo['emailfinder']&&countdowntip">
          <p>
            可搜索次数剩余
            <span
              :class="{red:true}"
              v-html="accountInfo.emailfinder.end_time!='-1'?'不限':(((searchType==0||searchType==1)?accountInfo.emailfinder.buy_purchaser_search_times:accountInfo.emailfinder.purchaser_search_times)||0)"
            ></span>次
            <a-divider type="vertical" v-show="searchType!=3" />
            <span v-show="searchType!=3">可查看数据剩余</span>
            <span
              v-show="searchType!=3"
              :class="{red:true}"
              v-html="((searchType==0||searchType==1)?accountInfo.emailfinder.buy_purchaser_detail_times:accountInfo.emailfinder.purchaser_detail_times)||0"
            ></span>
            <span v-show="searchType!=3">条</span>
          </p>
          <a-icon type="close" @click="countdowntip=false" />
        </div>
        <div class="table-header">
          <p>
            共检索到
            <span class="totalcount" v-html="this.totalCount"></span>条相关数据信息
          </p>

          <p class="sort">
            排序:
            <a-select size="small" v-model="orderType">
              <a-select-option :value="1">综合排序</a-select-option>
              <a-select-option :value="2">联系人数</a-select-option>
              <a-select-option :value="3">参展记录</a-select-option>
            </a-select>
          </p>
        </div>
        <div v-if="loading" style="text-align:center;margin:150px;">
          <a-spin tip="加载中...">
            <a-icon
              slot="indicator"
              type="loading"
              style="font-size: 48px;width:48px;height:48px;"
              spin
            />
          </a-spin>
        </div>
        <div v-else-if="dataSource.length">
          <ul class="list">
            <li v-for="(v,i) in dataSource" :key="i">
              <div v-if="searchType!=3||exhibition">
                <a :class="{'title':true}" @click="goToDetail(v)" v-html="v.company" />
                <p>
                  <span class="b" v-html="v.country"></span>
                  <a-divider type="vertical" />
                  <span v-html="`${v.expocount+'参展记录'}`"></span>
                </p>
              </div>
              <div v-else>
                <a
                  target="_blank"
                  :href="`/buyerfinder/exhibitors/${v.soid}?prId=${v.id}`"
                  :class="{'title':true}"
                  @click="$setStore('exhibition',v)"
                  v-html="v.prname"
                />
                <p>
                  <span
                    style="min-width:200px;display:inline-block;margin-right:40px;"
                    class="b"
                    v-html="`${'展会时间：'+v.timeStr}`"
                  ></span>
                  <span
                    style="min-width:400px;display:inline-block;margin-right:40px;"
                    v-html="`${'展会行业：'+v.industry}`"
                  ></span>
                  <span
                    style="min-width:30px;display:inline-block;"
                    v-html="`${'展会名录:'+v.expocount}`"
                  ></span>
                </p>
              </div>
            </li>
          </ul>
          <a-pagination
          v-if="accountInfo.comboType==='2'"
            v-model="pageNo"
            show-quick-jumper
            :total="totalCount"
            @change="changepage"
            :defaultPageSize="pageSize"
          />
        </div>
        <div v-else class="empty-list" v-show="emptyData">
          <p>
            未检索到
            <span v-html="oldSearchCondition"></span>相关数据信息!
          </p>
          <span>温馨提示：</span>
          <span>请检查您的输入是否正确或者更换新的词进行搜索吧。</span>
        </div>
      </div>
      <div class="initial" v-else></div>
    </div>
  </div>
</template>
<script>
const assert = require("assert");
import PinyinMatch from "pinyin-match";
import RechargeTip from "../RechargeTip";
import UpgradeTip from "../UpgradeTip";
// import CompanyInfo from "../CompanyInfo";
export default {
  data() {
    return {
      exhibition: false,
      product: {},
      initial: true,
      loading: false,
      advanced: true,
      countdowntip: true,
      orderType: 1,
      searchCondition: "",
      oldSearchCondition: "",
      emptyData: false,
      pageNo: 1,
      totalCount: 0,
      pageSize: 10,
      dataSource: [],
      base: {
        countryList: [],
        industryList: [],
        waimainList: [],
        sourceList: []
      },
      searchType: 0,
      selecter: {
        industry: "0",
        industryName: "",
        industrySearch: "",
        industryCode: "",
        country: "",
        countryName: "",
        alphabet: "全部",
        alphabetSearch: "",
        years: "",
        sourceId: "0",
        sourceName: ""
      },
      toggle: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.searchType = parseInt((to.query && to.query.st) || 0);
      vm.searchCondition = (to.query && to.query.search) || "";
      to.query.keyword && (vm.searchCondition = to.query.keyword);
      if (vm.searchCondition != "") {
        vm.search();
      }
      to.query.st == "2" && (document.title = "国外展会名录-知展360");
      to.query.st == "0" && (document.title = "国外采购商-知展360");
    });
  },
  watch: {
    orderType() {
      this.search();
    },
    $route(n, o) {
      if (n.query.st != o.query.st) {
        this.init();
      }
      (n.query.st == "2" || n.query.st == "0") &&
        (this.searchType = parseInt(n.query.st || 0));
    },
    searchType(n, o) {
      (n == "2" || n == "3") && (document.title = "国外展会名录-知展360");
      (n == "0" || n == "1") && (document.title = "国外采购商-知展360");
    }
  },
  computed: {
    accountInfo() {
      return this.$store.state.accountInfo;
    },
    countryList() {
      if (!!this.selecter.alphabetSearch) {
        return this.base.countryList.filter(c =>
          c.cnname.includes(this.selecter.alphabetSearch)
        );
      }
      if (this.selecter.alphabet != "全部") {
        return this.base.countryList.filter(c => {
          return (
            JSON.stringify([0, 0]) ==
            JSON.stringify(PinyinMatch.match(c.cnname, this.selecter.alphabet))
          );
        });
      }
      return this.base.countryList;
    },
    industryList() {
      if ("0,1".indexOf(this.searchType) > -1) {
        if (this.selecter.industryCode.length < 3) {
          return this.base.waimainList.filter(
            c =>
              c.parent.length == 3 &&
              (!!this.selecter.industrySearch
                ? c.name.includes(this.selecter.industrySearch)
                : true)
          );
        } else {
          return this.base.waimainList.filter(
            c =>
              c.parent.length == 6 &&
              (this.selecter.industryCode.length == 9
                ? c.parent == this.selecter.industryCode.substr(0, 6)
                : c.parent == this.selecter.industryCode) &&
              (!this.selecter.industrySearch
                ? true
                : c.name.includes(this.selecter.industrySearch))
          );
        }
        return this.base.waimainList;
      } else {
        if (this.selecter.industryCode.length < 3) {
          return this.base.industryList.filter(
            c =>
              c.parent == 0 &&
              (!!this.selecter.industrySearch
                ? c.name.includes(this.selecter.industrySearch)
                : true)
          );
        } else {
          return this.base.industryList.filter(
            c =>
              c.parent.length == 4 &&
              (this.selecter.industryCode.length == 8
                ? c.parent == this.selecter.industryCode.substr(0, 4)
                : c.parent == this.selecter.industryCode) &&
              (!this.selecter.industrySearch
                ? true
                : c.name.includes(this.selecter.industrySearch))
          );
        }
        return this.base.industryList;
      }
    }
  },
  methods: {
    init() {
      this.exhibition = false;
      this.product = {};
      this.initial = true;
      this.loading = false;
      this.advanced = true;
      this.countdowntip = true;
      this.orderType = 1;
      this.searchCondition = "";
      this.oldSearchCondition = "";
      this.emptyData = false;
      this.pageNo = 1;
      this.totalCount = 0;
      this.pageSize = 10;
      this.dataSource = [];
      this.searchType = this.$route.query.st || 0;
      this.selecter = {
        industry: "0",
        industryName: "",
        industrySearch: "",
        industryCode: "",
        country: "",
        countryName: "",
        alphabet: "全部",
        alphabetSearch: "",
        years: "",
        sourceId: "0",
        sourceName: ""
      };
      this.toggle = "";
    },
    handleTypeChange(v) {
      this.init();
      this.searchType = v || 0;
    },
    searchAlphabet() {
      this.selecter.alphabet = "全部";
    },
    search() {
      if (!this.accountInfo) {
        return this.$loginFrm();
      }
      // if (!!this.accountInfo && !this.accountInfo.company) {
      //   return this.$dialog(CompanyInfo);
      // }
      /* 
        无展商权益:unexhi
      */
      let n =
        (this.searchType == 0 || this.searchType == 1
          ? this.accountInfo.emailfinder.buy_purchaser_search_times
          : this.accountInfo.emailfinder.purchaser_search_times) || 0;
      if (this.accountInfo.emailfinder.end_time == "-1" && n == 0) {
        return this.$dialog(UpgradeTip, {
          tipType: "supgrade",
          accountInfo: this.accountInfo
        });
      }

      if (
        !this.searchCondition &&
        !this.selecter.countryName &&
        !this.selecter.industryName &&
        !this.selecter.sourceName
      ) {
        return this.$message.error("请输入相关检索词...");
      }
      if (!!this.searchCondition && !(this.searchCondition.length >= 2)) {
        return this.$message.error("请输入至少两个关键字");
      }

      this.initial = false;
      this.loading = true;
      let searchType = this.searchType + 1;
      if (searchType == 4 && !this.exhibition) {
        this.searchExhibitors();
      } else {
        this.$http
          .post("/zzPurchaserList", {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            orderType: this.orderType,
            countryId: this.selecter.country,
            industryId: this.selecter.industry,
            type: searchType,
            content: this.searchCondition,
            soId:
              "1,2".indexOf(searchType) > -1
                ? this.selecter.sourceId
                : (this.exhibition && this.product && this.product.soid) || 0
          })
          .then(res => {
            this.loading = false;
            if (!res.error) {
              console.log(res);
              this.totalCount = parseInt(res.totalCount || 0);
              this.pageNo = parseInt(res.pageNo || 1);
              this.pageSize = parseInt(res.pageSize || 10);
              this.dataSource = res.data.list || [];
              if (this.dataSource.length>5&&this.accountInfo.comboType==="1") {
                this.dataSource=this.dataSource.slice(0,5)
              }              
              this.emptyData = this.dataSource.length == 0;
              this.oldSearchCondition = this.searchCondition;
            } else {
              switch (res.error) {
                case 10504:
                  /* 
                  无剩余查询次数
                */
                  return this.$dialog(UpgradeTip, {
                    tipType: "supgrade",
                    accountInfo: this.accountInfo
                  });
                  break;
                case 1010: //搜索过多提醒
                  res.errorMsg &&
                    this.$notification.info({
                      message: "提醒",
                      description: res.errorMsg
                    });
                default:
                  res.errorMsg && this.$message.error(res.errorMsg);
                  break;
              }
            }
            document.getElementById("top").scrollIntoView();
            this.$refreshAccountInfo();
          })
          .catch(e => {
            this.loading = false;
            this.$refreshAccountInfo();
          });
      }
    },
    searchExhibitors() {
      this.$http
        .post("/zzExpositionList", {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          orderType: this.orderType,
          countryId: this.selecter.country,
          industryId: this.selecter.industry,
          content: this.searchCondition
        })
        .then(res => {
          console.log(res);
          this.loading = false;
          if (!res.error) {
            this.totalCount = parseInt(res.totalCount || 0);
            this.pageNo = parseInt(res.pageNo || 1);
            this.pageSize = parseInt(res.pageSize || 10);
            this.dataSource = (res.data && res.data.list) || [];
            if (this.dataSource.length>5&&this.accountInfo.comboType==="1") {
              this.dataSource=this.dataSource.slice(0,5)
            }               
            this.emptyData = this.dataSource.length == 0;
            this.oldSearchCondition = this.searchCondition;
          } else {
            switch (res.error) {
              case 10504:
                /* 
                  无剩余查询次数
                */
                return this.$dialog(UpgradeTip, {
                  tipType: "supgrade",
                  accountInfo: this.accountInfo
                });
                break;
              case 1010: //搜索过多提醒
                res.errorMsg &&
                  this.$notification.info({
                    message: "提醒",
                    description: res.errorMsg
                  });
                break;
              default:
                res.errorMsg && this.$message.error(res.errorMsg);
                break;
            }
          }
          document.getElementById("top").scrollIntoView();
          this.$refreshAccountInfo();
        })
        .catch(e => {
          this.loading = false;
          this.$refreshAccountInfo();
        });
    },
    changepage(v) {
      this.pageNo = v;
      this.search();
    },
    goToDetail(v) {
      if (!v.isLook) {
        if (!this.accountInfo) {
          return this.$loginFrm();
        }
        let n =
          (this.searchType == 0 || this.searchType == 1
            ? this.accountInfo.emailfinder.buy_purchaser_detail_times
            : this.accountInfo.emailfinder.purchaser_detail_times) || 0;
        if (n == 0) {
          return this.$dialog(UpgradeTip, {
            tipType: "upgrade",
            accountInfo: this.accountInfo
          });
        }
      }
      this.loading = true;
      var wetchat = this.$getWetchatExplore();
      var bbb;
      !wetchat && (bbb = window.open());
      //提前访问详情，保证次数正常

      this.$http
        .post("/zzGetPurchaserDetail", {
          pid: v.id || 0,
          type: this.searchType == 0 || this.searchType == 1 ? 1 : 2
        })
        .then(res => {
          this.loading = false;
          console.log(res);
          if (!res.error) {
            this.$refreshAccountInfo();
            if (wetchat) {
              this.$router.push({
                path: `/buyerfinder/detail/${v.id}?type=${this.searchType + 1}`
              });
            } else {
              bbb.location = `/buyerfinder/detail/${v.id}?type=${this
                .searchType + 1}`;
            }
          } else {
            this.$notification.info({
              message: "提醒",
              description: res.errorMsg
            });
            !wetchat && bbb.close();
          }
        })
        .catch(e => {
          this.loading = false;
          this.$router.push({ path: "/" });
          this.$notification.error({
            message: "错误",
            description: e
          });
          !wetchat && bbb.close();
        });
    },
    loadIndustryList() {
      this.$http.post("/zzIndustryList").then(res => {
        console.log(res);
        if (!res.error) {
          !!res.data.industry.length &&
            (this.base.industryList = res.data.industry);
          !!res.data.waimain.length &&
            (this.base.waimainList = res.data.waimain);
        }
      });
    },
    loadCountryList() {
      this.$http.post("/zzCountryList").then(res => {
        console.log(res);
        if (!res.error) {
          this.base.countryList = res.data.countryList;
        }
      });
    },
    loadSourceList() {
      this.$http.post("/zzSoIdList").then(res => {
        console.log(res);
        if (!res.error) {
          this.base.sourceList = res.data;
        }
      });
    },
    selectIndustry(v) {
      this.selecter.industry = v.id;
      this.selecter.industryName = v.name;
      this.selecter.industryCode = v.code;
      this.selecter.industrySearch = "";
    }
  },
  mounted() {
    this.pageNo = parseInt(this.$route.params.pageNo || 1);
  },
  created() {
    this.$refreshAccountInfo();
    this.loadCountryList();
    this.loadIndustryList();
    this.loadSourceList();
  }
};
</script>
<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
.buyerfinder-contenter {
  & /deep/ .ant-btn,
  & /deep/ .ant-input {
    border-radius: 0;
  }

  .btn-small-search {
    background: #f6f6f6;
    color: #999;
    font-size: 12px;
  }
  .anticon-search:before {
    color: #ececec;
    transform: scale(0.9);
    font-weight: bold;
  }
  background: #f9f9f9;
  .header {
    // height: 170px;
    padding-bottom: 20px;
    background: url("~@/assets/img/buyer_banner.jpg");
    text-align: left;
    .logocontain {
      margin: 0 auto;
      width: 1200px;
      height: 90px;
      .logo {
        display: inline-block;
        width: 200px;
        height: 70px;
        @include intop-icon;
        background-position: -40px -400px !important;
        margin: 15px 0 0 -10px;
      }
    }

    .advanced-search {
      margin: 0 auto;
      width: 1200px;
      background-color: #fff;
      & /deep/ .ant-input-affix-wrapper,
      & /deep/ .ant-btn {
        vertical-align: middle;
      }

      & > div:last-child {
        background-color: #ebf6ff;
        text-align: center;
        & /deep/ .ant-btn {
          height: 45px;
          &:first-child {
            width: 160px;
          }
          &:last-child {
            color: #008cd6;
            border: none;
            background-color: #0000;
          }
        }
      }
      .source,
      .industry,
      .country,
      .years {
        flex-flow: row;
        display: flex;
        border-bottom: 1px solid #e7e7e7;
        font-size: 12px;
        & > div {
          &:last-child > a {
            display: inline-block;
            margin-top: 18px;
          }
          color: #999;
          min-height: 53px;
          display: inline-block;
          min-width: 93px;
          padding: 0 25px;
          & > p {
            margin-top: 16px;
            line-height: 28px;
          }
          &:first-child {
            width: 93px;
            background: #f9f9f9;
          }
          &:nth-child(2) {
            flex: 1;

            & > div > :nth-child(2) {
              padding-top: 15px;
            }
            ul {
              margin: 0;
              padding: 0;
              list-style: none;
              overflow: hidden;
              &.collapse {
                height: 53px;
              }
              &:not(.collapse) {
                max-height: 200px;
                overflow-y: auto;
              }
              li {
                display: inline-block;
                margin: 16px 0 0 0;
                &:last-child {
                  margin: 16px 0 15px 0;
                }
              }
            }
          }
          .ant-btn {
            padding-top: 1px;
          }
          .ant-tag {
            border: none;
            border-radius: 0;
            font-size: 12px;
            background-color: #fff;
          }
          .countrylist {
            li {
              margin: 0;
              .ant-tag {
                margin-right: 3px;
                color: #3b6fc3;
              }
              .ant-tag-has-color {
                color: #fff;
              }
            }
          }
        }
      }
    }
    .search {
      width: 1200px;
      // height: 80px;
      margin: 0 auto;
      display: flex;

      & /deep/ .ant-select,
      & /deep/ .ant-select > .ant-select-selection,
      &
        /deep/
        .ant-select
        > .ant-select-selection
        > .ant-select-selection__rendered,
      & /deep/ .ant-input,
      & /deep/ .ant-btn {
        font-size: 14px;
        height: 45px;
        line-height: 45px;
        vertical-align: middle;
        border-radius: 0;
      }

      & /deep/ .ant-select > .ant-select-selection {
        background-color: #ebf6ff;
        width: 150px;
        color: #666;
      }
      & /deep/ .ant-input {
        border-right: none;
        border-left: none;
        &:focus,
        &:hover {
          box-shadow: none;
          border-color: #d9d9d9;
        }
      }
      .selected {
        background-color: #fff;
        border: 1px solid #d9d9d9;
        border-left: none;
        line-height: 45px;
        height: 45px;
        font-size: 12px;
        a {
          color: #008cd6;
        }
        span {
          margin-right: 10px;
          padding: 5px 10px;
          border: 1px solid #8ed6ff;
          color: #8c8a8b;
          i {
            margin-left: 20px;
            color: #d8d8d8;
          }
          &:hover {
            i {
              color: #008cd6;
            }
          }
        }
        padding: 0 10px;
      }
      .advanced {
        margin-left: 8px;
        color: #008cd6;
        background-color: #fff;
        border-color: #fff;
        &.active {
          color: #fff;
          background-color: #04517f;
          border-color: #04517f;
          &:after {
            content: " ";
            display: block;
            height: 0;
            width: 0;
            margin: -6px auto 0;
            border: solid #0000;
            border-width: 0 6px 5px;
            border-bottom-color: #fff;
          }
        }
      }
    }
  }
  .content {
    margin: auto;
    width: 1200px;
    min-height: 600px;
    .initial {
      &:before {
        display: block;
        height: 140px;
        width: 240px;
        background: red;
        margin: 100px auto 0;
        @include intop-icon;
        background-position: -370px 0px;
        content: " ";
      }
      &:after {
        display: block;
        content: "小二等候多时了，输入关键词开始检索吧！";
        text-align: center;
        font-size: 16px;
        color: #1dbc87;
        height: 140px;
        width: 220px;
        margin: 0 auto 100px;
      }
    }
    .datalist {
      margin-top: 10px;
      background: #fff;
      .tip {
        padding: 0 0 10px;
        background: #f9f9f9;
        font-size: 13px;
        color: #8a6d5b;
        position: relative;
        p {
          margin: 0;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background-color: #fcf8e3;
          .red {
            color: #f2352f;
          }
        }
        .anticon-close {
          position: absolute;
          top: 13px;
          right: 20px;
        }
      }
      .table-header {
        display: flex;
        flex-flow: row;
        border-bottom: 1px solid #e5e5e5;
        p {
          padding: 0 10px;
          display: inline-block;
          vertical-align: middle;
          margin: 0;
          line-height: 43px;
          height: 43px;
          flex: 1;
          font-size: 12px;
          color: #666;
          .totalcount {
            color: #f2352f;
            font-weight: bold;
          }
        }
        .sort {
          display: none;
          color: #999;
          font-size: 13px;
          text-align: right;
          .ant-select {
            margin: 0 10px;
            width: 100px;
          }
        }
      }
      .list {
        list-style: none;
        padding: 0px;
        li {
          height: 120px;
          border-bottom: 3px solid #f9f9f9;
          padding: 0 20px;
          position: relative;
          .title {
            line-height: 24px;
            display: inline-block;
            height: 24px;
            margin: 35px 0 0 0;
          }
          .has-linkman::after {
            content: " ";
            width: 40px;
            height: 24px;
            display: inline-block;
            line-height: 24px;
            vertical-align: top;
            @include intop-icon;
            background-position: -390px -655px !important;
          }
          p {
            margin: 5px 0 0 0;
            font-size: 13px;
            .b {
              font-weight: bold;
            }
          }
          .mark {
            position: absolute;
            right: 40px;
            top: 50px;
            display: inline-block;
            width: 90px;
            border: 1px solid #f0f0f0;
            height: 30px;
            line-height: 30px;
            padding: 0 20px;
            border-radius: 20px;
            background: #f9f9f9;
            color: #999;
            .anticon {
              color: #ff6b6b;
              margin-right: 5px;
            }
          }
        }
      }
    }
    .ant-pagination {
      height: 60px;
      padding: 10px 20px;
    }
    .empty-list {
      padding: 20px;
      p {
        font-size: 16px;
        color: #333;
        font-weight: bold;
        margin-bottom: 5px;
        span {
          color: #f00;
        }
      }
      & > span {
        font-size: 12px;
        display: block;
        margin-bottom: 5px;
        color: #999;
      }
    }
  }
  .header1 {
    padding-bottom: 20px;
    background: url("~@/assets/img/buyer_banner.jpg");
    text-align: left;
    border-bottom: 6px solid #ff6b6b;
    .logo {
      display: inline-block;
      width: 200px;
      height: 70px;
      @include intop-icon;
      background-position: -40px -400px !important;
      margin: 15px 0 0 300px;
    }
    & > div {
      text-align: center;
      color: #fff;
      &:nth-child(2) {
        font-size: 50px;
        margin-bottom: 20px;
      }
      &:nth-child(3) {
        color: #999;
        margin-bottom: 10px;
        & > span:first-child {
          margin-right: 40px;
        }
      }
    }
  }
}
</style>